import { useEffect, useState } from "react";

import CalendarIcon from "../../../../../Assets/Icons/calendar-icon.png";
import { useNotification } from "../../../../../Hooks/useNotification";
import { useApiErrorHandler } from "../../../../../Hooks/useApiErrorHandler";
import httpclient from "../../../../../Utils";
import { useBranch } from "../../../../../Hooks/useBranch";
import { useTimer } from "../../../../../Components/Context/TimerContext";
import LeftStats from "./LeftStats";

const getModifiedStats = (orderData, showRightStats = false) => {
  const [activeMember, totalMember] = orderData.activeTeamMember
    .split("/")
    .map(Number);

  const [activeDevice, totalDevice] = orderData.activeDevice
    .split("/")
    .map(Number);

  const modifiedStats = {
    leftStats: [
      {
        id: 1,
        label: "Today",
        value: "",
        icon: (
          <img
            src={CalendarIcon}
            alt="Calendar Icon"
            style={{ marginRight: "16px" }}
          />
        ),
        color: "#5D6679",
        fontSize: "16px",
      },
      {
        id: 2,
        label: showRightStats ? "Total" : "All",
        value: showRightStats ? orderData.todayOrder : orderData.totalOrder,
        color: "#9E9E9E",
      },
      {
        id: 3,
        label: "Priority",
        value: showRightStats
          ? orderData.todayPriorityOrder
          : orderData.totalPriorityOrder,
        color: "#E19133",
      },
      {
        id: 4,
        label: "In Queue",
        value: showRightStats
          ? orderData.todayInQueueOrder
          : orderData.totalInQueueOrder,
        color: "#1E3A8A",
      },
      {
        id: 5,
        label: "In Progress",
        value: showRightStats
          ? orderData.todayInProgressOrder
          : orderData.totalInProgressOrder,
        color: "#2196F3",
      },
      {
        id: 6,
        label: "GIT",
        value: showRightStats
          ? orderData.todayGitOrder
          : orderData.totalGitOrder,
        color: "#5D6679",
      },
      {
        id: 7,
        label: "Delay Picking",
        value: showRightStats
          ? orderData.todayDelayPickingOrder
          : orderData.totalDelayPickingOrder,
        color: "#5D6679",
      },
      {
        id: 8,
        label: "On Hold",
        value: showRightStats
          ? orderData.todayOnHoldOrder
          : orderData.totalOnHoldOrder,
        color: "#e65100",
      },
      {
        id: 9,
        label: "Completed",
        value: showRightStats
          ? orderData.todayCompletedOrder
          : orderData.totalCompletedOrder,
        color: "#4CAF50",
      },
      {
        id: 10,
        label: "Canceled",
        value: showRightStats
          ? orderData.todayCanceledOrder
          : orderData.totalCanceledOrder,
        color: "#F44336",
      },
    ],
    rightStats: [
      {
        id: 1,
        label: "Active Team Members",
        value: { active: activeMember, total: totalMember },
        color: "#7152F3",
      },
      {
        id: 2,
        label: "Active Devices",
        value: { active: activeDevice, total: totalDevice },
        color: "#00838F",
      },
    ],
  };

  return modifiedStats;
};

const OrdersOverview = ({
  showRightStats = false,
  hangingStyle = false,
  refreshTrigger,
  onStatusLabelClick,
}) => {
  // Add prop here
  const [overviewStats, setOverviewStats] = useState(null);
  const [loading, setLoading] = useState(false);
  const showNotification = useNotification();
  const handleApiError = useApiErrorHandler();
  const { currentBranch } = useBranch();
  const seconds = useTimer();
  const shouldRefreshData = seconds === 0;

  const fetchOverviewStats = async () => {
    const endpoint = "/dashboard/count-data";
    try {
      setLoading(true);
      const res = await httpclient.get(endpoint);
      const { data } = res;
      if (data.status === 200) {
        const modifiedStats = getModifiedStats(data.data, showRightStats);
        setOverviewStats(modifiedStats);
      } else {
        showNotification("error", data.msg || "Failed to fetch overview data");
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOverviewStats();
    // Whenever refreshTrigger changes (incremented by StatusTabs click),
    // this effect will run and call fetchOverviewStats
  }, [currentBranch, shouldRefreshData, refreshTrigger]); // Add refreshTrigger here

  const props = {
    overviewStats,
    showRightStats,
    hangingStyle,
    loading,
    onStatusLabelClick: showRightStats ? undefined : onStatusLabelClick,
  };

  return (
    <>
      <LeftStats {...props} />
    </>
  );
};

export default OrdersOverview;
